import Vue from 'vue';
import Map from './map.vue';
import Title from './tltle.vue';
import Image from './image.vue';
import Loading from './loading.vue';
import Confirm from './confirm.vue';
import VerifyFarm from './verify-farm.vue';
import TypeEvents from './type/events.vue';
import TypePropInput from './type/prop-input.vue';
import TypePropSupprot from './type/prop-support.vue';
import Timeline from './timeline/index.vue';
import PictureCard from './picture-card.vue';
import ToTop from './to-top.vue';
import Markdown from './markdown.vue';
import SupportUp from './support-up.vue';
import FormFarm from './forms/farm.vue';
import FormCycle from './forms/cycle.vue';
import FormPicture from './forms/picture.vue';
Vue.component('fm-map', Map);
Vue.component('fm-title', Title);
Vue.component('fm-image', Image);
Vue.component('fm-loading', Loading);
Vue.component('fm-confirm', Confirm);
Vue.component('fm-verify-farm', VerifyFarm);
Vue.component('fm-timeline', Timeline);
Vue.component('fm-picture-card', PictureCard);
Vue.component('fm-to-top', ToTop);
Vue.component('fm-markdown', Markdown);
Vue.component('fm-support-up', SupportUp);
Vue.component('fm-type-events', TypeEvents);
Vue.component('fm-type-prop-input', TypePropInput);
Vue.component('fm-type-prop-supprot', TypePropSupprot);
Vue.component('fm-form-farm', FormFarm);
Vue.component('fm-form-cycle', FormCycle);
Vue.component('fm-form-picture', FormPicture);
